<template>
	<div class="p10" v-loading.body="loading">
		<div class="el-row ly-bill-title">
			<el-col :span="6">
                <h1 style="padding-top:5px;">{{taskTitle}}</h1>
            </el-col>
            <el-col :span="18" class="tr">
            	<template>
            		<el-button type="primary" size="small" @click="submit()">
            			保存
            		</el-button>
            	</template>
            	<ly-router-button size="small">
                    取消
                </ly-router-button>
            </el-col>
		</div>
		<el-card class="box-card mt10 p10">
			<template>
			<el-col :span="8">
				<span>业务员</span>&nbsp;
				<el-select v-model="employee_id" placeholder="业务员">
					<el-option v-for="(item, index) in salesmans" :value="item.id" :label="item.name" :key="index">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="8">
				<span>品牌</span>&nbsp;
				<el-select v-model="product_brand_id" placeholder="品牌">
					<el-option v-for="(item, index) in brands" :value="item.value" :label="item.label" :key="index">
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="8">
				<span>年份</span>&nbsp;
				<el-select v-model="year" placeholder="年份">
					<el-option v-for="(item, index) in years" :value="item.value" :label="item.value" :key="index">
					</el-option>
				</el-select>
			</el-col>
			</template>
			<template>
				<div class="el-table el-table--fit el-table--striped el-table--enable-row-hover" style="width:500px;margin-top:80px;">
					<div class="el-table__header-wrapper">
						<table class="el-table__header" cellpadding="0" cellspacing="0" border="0" style="width:100%;">
							<thead>
								<tr>
									<th style="width:250px;"><div class="cell" style="text-align: center;">月份</div></th>
									<th style="width:250px;"><div class="cell" style="text-align: center;">任务(数量)</div></th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">1</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="january" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">2</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="february" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">3</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="march" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">4</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="april" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">5</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="may" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">6</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="june" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">7</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="jule" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">8</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="august" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">9</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="september" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">10</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="october" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">11</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="november" placeholder="请输入" clearable></el-input></td>
								</tr>
								<tr>
									<td style="width:250px;"><div class="cell" style="text-align: center;">12</div></td>
									<td style="width:250px;padding:2px 2%;"><el-input v-model="december" placeholder="请输入" clearable></el-input></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</template>
		</el-card>
	</div>
</template>
<script>
	import LyRouterButton from '@c/router-button'
	export default {
		components: {
			LyRouterButton
		},
		data () {
			return {
				taskTitle: '设置销售任务',
				loading: false,
				infoId: 0,
				employee_id: '', // 业务员id
				employee_name: '',
				salesmans: [], // 业务员
				product_brand_id: '', // 品牌id
				brands: [], // 品牌
				year: '',
				years: [], // 年份
				january: '', // 1
				february: '', // 2
				march: '', // 3
				april: '', // 4
				may: '', // 5
				june: '', // 6
				jule: '', // 7
				august: '', // 8
				september: '', // 9
				october: '', // 10
				november: '', // 11
				december: '' // 12
			}
		},
		mounted () {
			/* 年份生成 */
			var myDate = new Date();
			var startyear = myDate.getFullYear() - 1;
			for (var i = 0; i < 3; i++) {
				var time = startyear + i
				this.years.push({
					'value': time,
					'label': time
				})
			}
			this.querySalesman();
			this.queryBrand();
		},
		watch: {
			'$route': {
				handler (to, from) {
					// 清空之前的输入
					if (to.name === 'EditTask') {
						this.loading = true
						this.taskTitle = '修改销售任务'
						this.initEdit()
					}
				},
				immediate: true
			},
			'employee_id': function (v) {
				var vm = this;
				this.salesmans.map((item) => {
					if (item.id === v) {
						vm.employee_name = item.name
					}
				})
				this.queryTask()
			},
			'product_brand_id': function (v) {
				this.queryTask()
			},
			'year': function (v) {
				this.queryTask()
			}
		},
		methods: {
			initEdit () {
				// 获取详情的ID
				this.infoId = this.$route.params.id
				if (this.infoId) {
						this.$api.queryArr(['api/task', 'edit'], null, [this.infoId]).then((rs) => {
							// 设置表单中的回填数据
							Object.keys(rs).forEach(key => {
								if (typeof this[key] !== undefined) {
									this[key] = rs[key]
								}
							})
							// this.$refs['searchForm'].initBindFormData(rs)
							// 设置UUID
							// this.submitForm.uuid = this.$utils.createUUID()
							// 取消加载
							setTimeout(() => {
									this.loading = false
							}, 100)
						}).catch((error) => {
							// 取消加载
							this.loading = false
							this.$message({
									message: error,
									type: 'warning'
							})
						})
				} else {
						this.$message({
								message: '无ID',
								type: 'warning'
						})
				}
			},
		 	/* 获取业务员 */
		 	querySalesman () {
				 // 2021-01-07 小蘑菇要求不限制返回的条数，同时加入type参数，用于只返回业务员
		 		this.$api.query('api/staff', {page: 1, size: 999,type: 2, route: 'staff'}).then((rs) => {
		 			this.salesmans = rs.data
		 		})
		 	},
		 	queryBrand () {
		 		this.$api.query('api/brand').then((rs) => {
		 			this.brands = rs
		 		})
		 	},
		 	submit () {
		 		let data = {
		 			employee_id: this.employee_id,
		 			employee_name: this.employee_name,
		 			product_brand_id: this.product_brand_id,
		 			year: this.year,
		 			january: this.january, // 1
					february: this.february, // 2
					march: this.march, // 3
					april: this.april, // 4
					may: this.may, // 5
					june: this.june, // 6
					jule: this.jule, // 7
					august: this.august, // 8
					september: this.september, // 9
					october: this.october, // 10
					november: this.november, // 11
					december: this.december // 12
		 		}
				let url = 'api/task'
				let method = 'create'
				if (this.infoId !== 0) {
					url = url + '/' + this.infoId
					method = 'save'
					data.id = this.infoId
				}
		 		this.$api[method](url, data).then((rs) => {
		 			this.$alert('数据保存成功', '销售任务', {
						confirmButtonText: '确定',
						callback: action => {
								// 跳转到list页面
								this.$router.push('/bill/task/list')
						}
					})
		 		}).catch((err) => {
					this.$alert(err, '操作提示', {
                        confirmButtonText: '确定'
                    })
				})
		 	},
		 	/* 搜索当前销售任务 */
		 	queryTask () {
		 		if (!this.employee_id || !this.product_brand_id || !this.year) {
		 			return
		 		}
		 		var data = {
		 			employee_id: this.employee_id,
		 			product_brand_id: this.product_brand_id,
		 			year: this.year
		 		}
		 		this.$api.query('api/task', data).then((rs) => {
		 			if (rs.data && rs.data.length > 0) {
		 				this.january = rs.data[0].january
			 			this.february = rs.data[0].february
			 			this.march = rs.data[0].march
			 			this.april = rs.data[0].april
			 			this.may = rs.data[0].may
			 			this.june = rs.data[0].june
			 			this.jule = rs.data[0].jule
			 			this.august = rs.data[0].august
			 			this.september = rs.data[0].september
			 			this.october = rs.data[0].october
			 			this.november = rs.data[0].november
			 			this.december = rs.data[0].december
		 			} else {
		 				this.january = ''
		 				this.february = ''
		 				this.march = ''
		 				this.april = ''
			 			this.may = ''
			 			this.june = ''
			 			this.jule = ''
			 			this.august = ''
			 			this.september = ''
			 			this.october = ''
			 			this.november = ''
			 			this.december = ''
		 			}
		 		})
		 	}
		 }
	}
</script>